import React, { forwardRef } from "react";

const CalendarInput = forwardRef(({ value, onClick, placeholder = 'Select Date', isReadOnly = false }, ref) => (
  <input
    type="text"
    className="w-100 customInputControl"
    value={value || ""}
    onClick={onClick}       // opens the calendar
    placeholder={placeholder}
    ref={ref}
    readOnly={isReadOnly}                // blocks soft keyboard
  />
));

export default CalendarInput;
